import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule, RequestOptions} from '@angular/http';

import {RouterModule, Routes} from '@angular/router';
import {AppComponent} from './app.component';

import {FlexLayoutModule} from '@angular/flex-layout';


import {TwsHomeComponent} from './tws-home/tws-home.component';

import {TwsMacchineComponent} from './tws-macchine/tws-macchine.component';
import {TwsCarrelloComponent} from './tws-carrello/tws-carrello.component';
import {TwsMacchinaComponent} from './tws-macchina/tws-macchina.component';

import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatListModule} from '@angular/material/list';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatInputModule} from '@angular/material/input';
import {MatSnackBarModule} from '@angular/material/snack-bar';

//import {MaterialModule, matDatepickerModule, MdNativeDateModule} from '@angular/material';
import {AppSettings} from './models/AppSettings';
import {AppMenu} from './models/AppMenu';

import {TwsDocumentazioneComponent} from './tws-documentazione/tws-documentazione.component';
import {TwsAccessoriComponent} from './tws-accessori/tws-accessori.component';
import {TwsAccessorioComponent} from './tws-accessorio/tws-accessorio.component';
import {TwsGaranziaComponent} from './tws-garanzia/tws-garanzia.component';
import {TwsCategoriaComponent} from './tws-categoria/tws-categoria.component';
import {TwsCategoriaInlineComponent} from './tws-categoria/tws-categoria-inline.component';
import { TwsBachecaComponent } from './tws-bacheca/tws-bacheca.component';

import {Ng2CompleterModule} from "ng2-completer";
import {RicambiService} from './service/ricambi.service';
import {WebSocketService} from 'angular2-websocket-service'
import {ServerSocket} from './service/server-socket.service'
import {UserService} from './service/user.service';
import {TranslatePipe} from './service/translate.pipe';
import {TruncatePipe} from './service/truncate.pipe';
import {TwsMatricoleComponent} from './tws-matricole/tws-matricole.component';
import {TwsLoginComponent} from './tws-login/tws-login.component';
import {LoggedInGuard} from './service/logged.guard';
import {TwsToolbarComponent} from './tws-toolbar/tws-toolbar.component';
import {DefaultRequestOptions} from './service/CustomRequest';
import {TwsFooterComponent} from './tws-footer/tws-footer.component';
import {CurrencyFormatPipe} from './currency-format.pipe';
import {TwsRicambiComponent} from './tws-ricambi/tws-ricambi.component';
import {FileSizePipe} from './service/file-size.pipe';
import {MAT_DATE_FORMATS, DateAdapter, NativeDateAdapter} from '@angular/material';


const MY_DATE_FORMATS = {
    parse: {
        dateInput: {month: 'short', year: 'numeric', day: 'numeric'}
    },
    display: {
        // dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
        dateInput: 'input',
        monthYearLabel: {year: 'numeric', month: 'short'},
        dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
        monthYearA11yLabel: {year: 'numeric', month: 'long'},
    }
};

export class MyDateAdapter extends NativeDateAdapter {


    format(date: Date, displayFormat: Object): string {
        let monthNames = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu",
            "Lug", "Ago", "Set", "Ott", "Nov", "Dic"
        ];
        if (displayFormat == "input") {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            return this._to2digit(day) + '/' + this._to2digit(month) + '/' + year;
        } else {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            return monthNames[month-1] + '/' + year;

        }
    }


    stringToDate(_date: string, _format: string, _delimiter: string): Date {
        var formatLowerCase = _format.toLowerCase();
        var formatItems = formatLowerCase.split(_delimiter);
        var dateItems = _date.split(_delimiter);
        var monthIndex = formatItems.indexOf("mm");
        var dayIndex = formatItems.indexOf("dd");
        var yearIndex = formatItems.indexOf("yyyy");
        var month = parseInt(dateItems[monthIndex]);
        month -= 1;
        var formatedDate = new Date(parseInt(dateItems[yearIndex]), month, parseInt(dateItems[dayIndex]));
        if (month != formatedDate.getMonth()){
            return null;
        }
        return formatedDate;
    }


    parse(dat: any): Date {
        if (!dat) {
            return null;
        }
        if (dat instanceof Date) {
            return dat;
        }
        return this.stringToDate(dat, "dd/mm/yyyy", "/");
    }

    private _to2digit(n: number) {
        return ('00' + n).slice(-2);
    }
}


const appRoutes: Routes = [
    {
        path: 'home', component: TwsHomeComponent,
        canActivate: [LoggedInGuard]
    },
    {path: 'login', component: TwsLoginComponent},
    {path: 'login/:id', component: TwsLoginComponent},
    {
        path: 'scheda/:id', component: TwsMacchinaComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'accessorio/:id', component: TwsAccessorioComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'richiestaGaranzia/:id', component: TwsGaranziaComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'richiestaGaranzia', component: TwsGaranziaComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'documentazione', component: TwsDocumentazioneComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'ricambi', component: TwsRicambiComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'bacheca', component: TwsBachecaComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'ricambi/:id', component: TwsRicambiComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'documentazione/:id', component: TwsDocumentazioneComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'documentazione/:id/:search', component: TwsDocumentazioneComponent,
        canActivate: [LoggedInGuard]
    },

    {
        path: 'macchine',
        component: TwsMacchineComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'macchine/:id',
        component: TwsMacchineComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'carrello',
        component: TwsCarrelloComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'accessori',
        component: TwsAccessoriComponent,
        canActivate: [LoggedInGuard],
        data: [{azione: ''}]
    },
    {
        path: 'accessori/:id',
        component: TwsAccessoriComponent,
        canActivate: [LoggedInGuard],
        data: [{azione: ''}]
    },
    {
        path: 'accessori/:id/lista/:categoria',
        component: TwsAccessoriComponent,
        canActivate: [LoggedInGuard],
        data: [{azione: 'lista'}]
    },
    {
        path: 'accessori/:id/comp/:categoria',
        component: TwsAccessoriComponent,
        canActivate: [LoggedInGuard],
        data: [{azione: 'comp'}]
    },
    {
        path: 'richiestaGaranzia',
        component: TwsGaranziaComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: 'matricole',
        component: TwsMatricoleComponent,
        canActivate: [LoggedInGuard]
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    }
];

const MATERIAL_UI_MODULES = [
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    BrowserModule,
    Ng2CompleterModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatListModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatInputModule,
    MatSnackBarModule,
     FlexLayoutModule,
//    MaterialModule, matDatepickerModule, MdNativeDateModule,
    RouterModule.forRoot(appRoutes, {useHash: true}),
    //RouterModule.forRoot(appRoutes),
    // MaterialModule.forRoot()

];



@NgModule({
    declarations: [
        AppComponent,
        TwsMacchinaComponent,
        TwsHomeComponent,
        TwsMacchineComponent,
        TwsCarrelloComponent,
        TwsAccessoriComponent,
        TwsAccessorioComponent,
        TwsGaranziaComponent,
        TwsCategoriaComponent,
        TwsCategoriaInlineComponent,
        TwsDocumentazioneComponent,
        TranslatePipe,
        TruncatePipe,
        TwsMatricoleComponent,
        TwsLoginComponent,
        TwsToolbarComponent,
        TwsFooterComponent,
        CurrencyFormatPipe,
        TwsRicambiComponent,
        FileSizePipe,
        TwsBachecaComponent
    ],
    imports: [
        ...MATERIAL_UI_MODULES
    ],
    providers: [ServerSocket, WebSocketService, RicambiService, AppSettings, TranslatePipe, TruncatePipe, UserService, LoggedInGuard, {provide: RequestOptions, useClass: DefaultRequestOptions},
        {provide: DateAdapter, useClass: MyDateAdapter},
        {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts